var _circle, _rect, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E51717"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(4 4)",
    fill: "#E51717"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9993,
    cy: 12.0003,
    r: 7.33333,
    fill: "#E51717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66597 8.66694C8.92631 8.40659 9.34843 8.40659 9.60877 8.66694L11.9993 11.0574L14.3898 8.66694C14.6502 8.40659 15.0723 8.40659 15.3326 8.66694C15.593 8.92729 15.593 9.3494 15.3326 9.60975L12.9421 12.0002L15.3326 14.3908C15.593 14.6512 15.593 15.0733 15.3326 15.3336C15.0723 15.594 14.6502 15.594 14.3898 15.3336L11.9993 12.943L9.60877 15.3336C9.34842 15.594 8.92631 15.594 8.66596 15.3336C8.40562 15.0733 8.40562 14.6512 8.66596 14.3908L11.0565 12.0002L8.66597 9.60975C8.40562 9.3494 8.40562 8.92729 8.66597 8.66694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.b309ab6e5742803ea63eac7a112d7707.svg";
export { ForwardRef as ReactComponent };